import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faLinkedinIn, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useToast } from '../hooks/use-toast';
import c2cMap from '../assets/images/c2c-map.png';

const c2cScriptUrl = 'https://app.contexttocall.com/assets/cdn/c2c.js';
const c2cPointId = '60424735f74ac306c1bfa900C2CSRC677838cabe93ab03faf8ee9a';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    interest: '',
    message: ''
  });

  useEffect(() => {
    let isMounted = true;

    const initializeC2C = () => {
      if (isMounted && typeof window.createPoint === 'function') {
        window.createPoint(c2cPointId);
      }
    };

    const existingScript = document.querySelector(`script[src="${c2cScriptUrl}"]`);
    if (existingScript) {
      if (typeof window.createPoint === 'function') {
        initializeC2C();
      } else {
        existingScript.addEventListener('load', initializeC2C, { once: true });
      }

      return () => {
        isMounted = false;
        existingScript.removeEventListener('load', initializeC2C);
      };
    }

    const script = document.createElement('script');
    script.src = c2cScriptUrl;
    script.async = true;
    script.addEventListener('load', initializeC2C);
    document.body.appendChild(script);

    return () => {
      isMounted = false;
      script.removeEventListener('load', initializeC2C);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mock form submission
    console.log('Form submitted:', formData);
    
    toast({
      title: 'Message Sent!',
      description: 'Thank you for reaching out. We\'ll get back to you shortly.',
    });
    
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      interest: '',
      message: ''
    });
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <div className="contact-grid">
          <div className="contact-info reveal">
            <div className="section-label">Contact Us</div>
            <h3>Let's Talk Business</h3>
            <p>
              Our team is ready to help you find the right C2C product for your needs. 
              From quick demos to enterprise deployments — reach out and we'll respond promptly.
            </p>
            
            <div className="contact-details">
              <div className="contact-detail">
                <FontAwesomeIcon icon={faLocationDot} />
                <span>10 N Longfellow Dr, West Windsor, NJ 08550, USA</span>
              </div>
              <div className="contact-detail">
                <FontAwesomeIcon icon={faPhone} />
                <a href="tel:+18663887785">+1-866-388-7785 Ext. 310</a>
              </div>
              <div className="contact-detail">
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:alley@contexttocall.com">alley@contexttocall.com</a>
              </div>
              <div className="c2c-contact-embed">
                <label className="Ns3iSndZjCeqn8t19378" id="Ns3iSndZjCeqn8t19378" htmlFor="c2c_call" aria-describedby="tooltip-call" aria-haspopup="true" tabIndex="0"></label>
                <label className="gdoAqsMqJn7mylo18Tpk" id="gdoAqsMqJn7mylo18Tpk" htmlFor="c2c_sms" aria-describedby="tooltip-sms" aria-haspopup="true" tabIndex="0"></label>
                <label className="jZuL2b9WUG9YdK8E8IXW" id="jZuL2b9WUG9YdK8E8IXW" htmlFor="c2c_email" aria-describedby="tooltip-email" aria-haspopup="true" tabIndex="0"></label>
              </div>
            </div>
            
            <div className="social-links">
              <div className="social-label">Follow Us</div>
              <div className="social-icons">
                <a href="https://www.facebook.com/C2CBusinessSolutions/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://twitter.com/contexttocall" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a href="https://www.linkedin.com/showcase/click-2-call/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
                <a href="https://www.youtube.com/channel/UC0F1izs-sXIhdrS_KmFD5IA" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>
          </div>
          <div className="contact-map-wrapper reveal">
            <img src={c2cMap} alt="Context to Call global availability map" className="contact-map-image" />
          </div>
{/*           
          <div className="contact-form-wrapper reveal">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-field">
                  <Label htmlFor="firstName">First Name</Label>
                  <Input 
                    id="firstName"
                    type="text"
                    placeholder="John"
                    value={formData.firstName}
                    onChange={(e) => handleChange('firstName', e.target.value)}
                    required
                  />
                </div>
                <div className="form-field">
                  <Label htmlFor="lastName">Last Name</Label>
                  <Input 
                    id="lastName"
                    type="text"
                    placeholder="Smith"
                    value={formData.lastName}
                    onChange={(e) => handleChange('lastName', e.target.value)}
                    required
                  />
                </div>
              </div>
              
              <div className="form-field">
                <Label htmlFor="email">Business Email</Label>
                <Input 
                  id="email"
                  type="email"
                  placeholder="john@company.com"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  required
                />
              </div>
              
              <div className="form-field">
                <Label htmlFor="company">Company</Label>
                <Input 
                  id="company"
                  type="text"
                  placeholder="Acme Inc."
                  value={formData.company}
                  onChange={(e) => handleChange('company', e.target.value)}
                  required
                />
              </div>
              
              <div className="form-field">
                <Label htmlFor="interest">Interested In</Label>
                <Select value={formData.interest} onValueChange={(value) => handleChange('interest', value)}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a product" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="core">Context to Call (Core Platform)</SelectItem>
                    <SelectItem value="softphone">C2C Softphone</SelectItem>
                    <SelectItem value="appliance">C2C Appliance (On-Premise)</SelectItem>
                    <SelectItem value="ai">C2C AI Agent</SelectItem>
                    <SelectItem value="enterprise">Full Suite / Enterprise</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              
              <div className="form-field">
                <Label htmlFor="message">Message</Label>
                <Textarea 
                  id="message"
                  placeholder="Tell us about your communication needs..."
                  rows={4}
                  value={formData.message}
                  onChange={(e) => handleChange('message', e.target.value)}
                  required
                />
              </div>
              
              <Button type="submit" size="lg" className="submit-btn">
                Send Message <Mail size={18} />
              </Button>
            </form>
          </div> */}

        </div>
      </div>
    </section>
  );
};

export default Contact;
